// src/components/ItemModalBody.jsx
import { useState, useEffect } from "react";
import { fetchReviews } from "../utils/fetchReviews";

const ItemModalBody = ({ item, item_size_min_max, formattedPrice, url, getPrefixWidth, className }) => {
 const [reviews, setReviews] = useState([]);
 const [isDetailsOpen, setIsDetailsOpen] = useState(false);

 useEffect(() => {
  if (!item) return;
  // 商品コードでレビューをフィルタ
  fetchReviews().then((data) => {
   const filtered = data.filter((review) => review.item_inhouse_code.toString() === item.item_inhouse_code.toString());
   setReviews(filtered);
  });
 }, [item]);

 // detailsが開かれたタイミングでsummaryの位置へスクロール
 const handleToggle = (e) => {
  setIsDetailsOpen(e.target.open);
  if (e.target.open) {
   // 少し遅延させてレイアウト再計算後に実行
   setTimeout(() => {
    const container = document.querySelector(".p-item-modal__body");
    // const container = document.querySelector(".p-item-modal__body-inner");
    const summaryEl = e.target.querySelector("summary");
    if (container && summaryEl) {
     const containerRect = container.getBoundingClientRect();
     const summaryRect = summaryEl.getBoundingClientRect();
     const targetScrollTop = summaryRect.top - containerRect.top + container.scrollTop;

     // デバッグ用ログ
     console.log("Container:", container);
     console.log("Summary Element:", summaryEl);
     console.log("ContainerRect:", containerRect);
     console.log("SummaryRect:", summaryRect);
     console.log("Calculated targetScrollTop:", targetScrollTop);

     container.scrollTo({
      top: targetScrollTop,
      behavior: "smooth",
     });
    }
   }, 50); // 50ms程度の遅延
  }
 };

 return (
  <>
   <div className={`p-item-modal__body-inner ${className}`}>
    <div className="p-item-modal__info">
     <p className="p-item-modal__name">{item.item_category}</p>
     <p className="p-item-modal__number-color">
      <span>{item.item_number}</span>
      <span>{item.item_color_en}</span>
     </p>
     <p className="p-item-modal__size">サイズ：{item_size_min_max}</p>
     <p className="p-item-modal__heel-cm">ヒールの高さ：{item.item_heel_cm}</p>
     <p className="p-item-modal__width-e">
      ウィズ：{item.item_width_e}
      {getPrefixWidth(item.item_width_e)}
     </p>
     <p className="p-item-modal__price">
      <span>{formattedPrice(item.item_price)}</span>
      <span>円（税込）</span>
     </p>
    </div>

    <div className="p-item-modal__url-wrap">
     {item.item_ec_link === "通常販売" && (
      <a className="p-item-modal__url p-item-modal__url--ec" href={url} target="_blank" rel="noopener">
       <span>公式オンラインショップ（kutsu.com）へ</span>
      </a>
     )}
     {item.item_ec_link === "未発売（店舗限定）" && (
      <>
       <a className="p-item-modal__url p-item-modal__url--ec-notinstock" href="https://stores.chiyodagrp.co.jp/" target="_blank" rel="noopener">
        <span>
         こちらの商品は、現在店舗販売のみになります。
         <br />
         お買い求めはお近くの店舗へお問い合わせください。
        </span>
       </a>
      </>
     )}
     {item.item_ec_link === "販売終了" && (
      <div className="p-item-modal__url p-item-modal__url--ec p-item-modal__url--ec-info">
       <input id="url_tooltip" type="checkbox" autoComplete="off" />
       <label htmlFor="url_tooltip" className="p-url-tooltip-trigger">
        <span className="sr-only">
         公式オンラインショップでの通信販売は終了しております。詳細については
         <span className="is-sp">クリック</span>
         <span className="is-pc">タップ</span>してご確認ください。
        </span>
       </label>
       <div className="p-url-tooltip">
        <div className="p-url-tooltip__info">
         <p>
          こちらの商品につきましては
          <span className="is-pc">、</span>
          <br className="is-sp" />
          公式オンラインショップでの<span>通信販売は終了</span>しております。
         </p>
         <p>
          ご希望の場合は、実店舗の在庫をお調べいたしますので
          <span className="is-pc">、</span>
          <br className="is-sp" />
          お電話にてお問い合わせください。
         </p>
        </div>
        <div className="p-url-tooltip__phone">
         <div className="p-url-tooltip__phone-caller">
          <p>チヨダインフォメーション</p>
          <p>
           <span className="is-sp">03-5315-4081</span>
           <span className="is-pc">
            <img src="/assets/images/common/chiyoda_information/phone_number.svg" alt="03-5315-4081" width="289" height="41" />
           </span>
          </p>
          <p>
           受付時間：10:00～18:30
           <br className="is-pc" />
           （月～金曜日、祝日を除く）
          </p>
         </div>
         {/* <p className="p-url-tooltip__phone-caution">
             年末年始休業期間：
             <br className="is-sp" />
             2024年12月28日（土）〜2025年1月5日（日）
            </p> */}
        </div>
        <p className="p-url-tooltip__note">
         店舗の在庫調査からご報告まで、お時間をいただく場合がございます。
         <br />
         在庫状況により、ご希望に添えない場合がございます。予めご了承ください。
        </p>
       </div>
      </div>
     )}
     <a
      className="p-item-modal__url p-item-modal__url--fuwaraku"
      href={item.item_jp_link}
      // target={url.includes("fuwaraku.jp") || url.includes("localhost") || url.includes("dev015") ? "_self" : "_blank"}
      data-category={item.item_category}
     >
      <span>{item.item_category}のページはこちら</span>
     </a>

     {/* 商品レビュー表示 ローンチ前につき、非表示中　*/}
     {/* {reviews.length > 0 && (
      <details className="p-item-modal__reviews-details" onToggle={handleToggle}>
       <summary>{isDetailsOpen ? "商品レビューを閉じる" : "商品レビューを見る"}</summary>
       <div className="p-item-modal__reviews">
        <h3>商品レビュー</h3>
        {reviews.map((review, index) => (
         <div key={index} className="p-item-modal__review">
          <p>
           <strong>ニックネーム:</strong> {review.nickname}
          </p>
          <p>
           <strong>レビュー件名:</strong> {review.title}
          </p>
          <p>
           <strong>投稿日時:</strong> {review.date}
          </p>
          <p>
           <strong>評価:</strong> {review.rating} ({"⭐️".repeat(Math.floor(review.rating))}
           {review.rating % 1 ? "⭐️" : ""})
          </p>
          <p>
           <strong>内容:</strong> {review.content}
          </p>
         </div>
        ))}
       </div>
      </details>
     )} */}
    </div>
   </div>
  </>
 );
};

export default ItemModalBody;
